// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconRmsTransferImage_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M30 3H2V5H30L30 27H32L32 5V3H30ZM23.7381 8L22.2381 7.00001V9.71824C21.6987 9.73042 21.1438 9.82661 20.5983 10C19.1226 10.469 17.7158 11.5024 16.8721 12.9639C16.229 14.0777 15.9526 15.304 16.0066 16.5C16.0775 16.3526 16.1551 16.2057 16.2381 16.0619C17.5072 13.8638 19.7408 12.2636 22.2381 12.2607V15L28.2381 11L27 10.1746L23.7381 8ZM0 8H20.2381V8.02019C18.9668 8.38184 17.7387 9.05793 16.7168 10H2V24L8.4375 16.0811L15 24L19.5 19.5L25 26V15.5624L27 14.2291V29H0V8Z" class="svg-bg"/>
</svg>
`;
/**
 * IconRmsTransferImage is a generated icon component.
 */
let IconRmsTransferImage = IconRmsTransferImage_1 = class IconRmsTransferImage extends IconBaseElement {
    render() {
        return html `${IconRmsTransferImage_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconRmsTransferImage.icons = new Map([
    ['s8', _s32IconSvg],
    ['s12', _s32IconSvg],
    ['s16', _s32IconSvg],
    ['s24', _s32IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconRmsTransferImage = IconRmsTransferImage_1 = __decorate([
    customElement('zui-icon-rms-transfer-image')
], IconRmsTransferImage);
export { IconRmsTransferImage };
